import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { BusinessComponentService } from './../business-component.service';
import { RemoveProjectFromBCRequest } from '../models/client-project.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'remove-proj-from-bizcomp',
    templateUrl: './remove-project-manageBC.component.html',
    styleUrls: ['./remove-project-manageBC.component.scss']
})

export class RemoveProjectFromBusinessComp implements OnInit, AfterViewInit {

    constructor(@Inject(DOCUMENT) private _document: Document, private renderer: Renderer2, private _businessComponentService: BusinessComponentService) {
    }
    @Input() selectedBusinessCompId: number;
    @Input() selectedClientProjectId: number[];
    @Input() engagementId: number;
  @Output() modelClose= new EventEmitter<void>();
  private routeSubscription: Subscription;
    ngOnInit(): void {       
     
    }

    ngAfterViewInit(): void {
        let modalBody = this._document.getElementById('modal-content-body') as HTMLElement;
        if (modalBody) {
            this.renderer.setStyle(modalBody, 'height', '63%');
            this.renderer.setStyle(modalBody, 'width', '35%');           
        }
    }

    closeConfimationBox() {
       this.modelClose.emit();
    }

    removeSelectedProject() {
        const deleteRequest: RemoveProjectFromBCRequest = {
            projectIds: this.selectedClientProjectId,
            engagementId: this.engagementId,
            businessComponentId: this.selectedBusinessCompId
        };
        this._businessComponentService.removeProjectFromBusinessComponent(deleteRequest).subscribe();
        this.closeConfimationBox();
    }
    ngOnDestroy()
    {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }
}
